import { render, staticRenderFns } from "./BindTel.vue?vue&type=template&id=c5ac3aee&scoped=true&"
import script from "./BindTel.vue?vue&type=script&lang=js&"
export * from "./BindTel.vue?vue&type=script&lang=js&"
import style0 from "./BindTel.vue?vue&type=style&index=0&id=c5ac3aee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ac3aee",
  null
  
)

export default component.exports